"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var util_1 = require("../util");
var export_1 = require("../utils/export");
var DashboardModule = /** @class */function () {
  function DashboardModule(xhr) {
    this.xhr = xhr;
  }
  DashboardModule.prototype.exportToPdf = function (projectId, dashboardUri, filters, pollingOptions) {
    if (filters === void 0) {
      filters = [];
    }
    if (pollingOptions === void 0) {
      pollingOptions = {};
    }
    return __awaiter(this, void 0, void 0, function () {
      var sanitizedFilters, payload, response, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            sanitizedFilters = export_1.sanitizeDateFilters(filters);
            payload = this.getDashboardExportPayload(dashboardUri, sanitizedFilters);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 4,, 5]);
            return [4 /*yield*/, this.xhr.post("/gdc/internal/projects/" + projectId + "/exportDashboard", {
              body: payload
            })];
          case 2:
            response = _a.sent();
            return [4 /*yield*/, this.pollPdfFile(response, pollingOptions)];
          case 3:
            return [2 /*return*/, _a.sent()];
          case 4:
            error_1 = _a.sent();
            throw error_1;
          case 5:
            return [2 /*return*/];
        }
      });
    });
  };
  DashboardModule.prototype.pollPdfFile = function (response, pollingOptions) {
    return __awaiter(this, void 0, void 0, function () {
      var data, exportResponse;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            data = response.getData();
            return [4 /*yield*/, util_1.handleHeadPolling(this.xhr.head.bind(this.xhr), data.uri, export_1.isExportFinished, pollingOptions)];
          case 1:
            exportResponse = _a.sent();
            return [2 /*return*/, exportResponse];
        }
      });
    });
  };
  DashboardModule.prototype.getDashboardExportPayload = function (dashboardUri, filters) {
    if (filters.length) {
      return {
        dashboardExport: {
          dashboardUri: dashboardUri,
          filters: filters
        }
      };
    }
    // minimize payload
    return {
      dashboardExport: {
        dashboardUri: dashboardUri
      }
    };
  };
  return DashboardModule;
}();
exports.DashboardModule = DashboardModule;